/* istanbul ignore file */
import { MapViewInputManager } from 'cd-eft/business/MapViewInputManager/MapViewInputManager';
import { TextSketchInputProperties } from 'cd-eft/business/MapViewInputManager/TextSketchInputProperties';
import { computed } from 'mobx';
import { DrawingsModel } from '../model/DrawingsModel';
import { DrawingToolViewModel } from './DrawingToolViewModel';

export class DrawingToolsetViewModel {
  public readonly textDrawingProps: TextSketchInputProperties;
  public readonly pointTool: DrawingToolViewModel;
  public readonly polylineTool: DrawingToolViewModel;
  public readonly polygonTool: DrawingToolViewModel;
  public readonly rectangleTool: DrawingToolViewModel;
  public readonly circleTool: DrawingToolViewModel;
  public readonly textTool: DrawingToolViewModel;
  public readonly deleteTool: DrawingToolViewModel;

  constructor(inputManager: MapViewInputManager, drawings: DrawingsModel) {
    this.textDrawingProps = new TextSketchInputProperties();
    this.textDrawingProps.text = '';

    this.pointTool = new DrawingToolViewModel('draw-point', inputManager, drawings);
    this.polylineTool = new DrawingToolViewModel('draw-polyline', inputManager, drawings);
    this.polygonTool = new DrawingToolViewModel('draw-polygon', inputManager, drawings);
    this.rectangleTool = new DrawingToolViewModel('draw-rectangle', inputManager, drawings);
    this.circleTool = new DrawingToolViewModel('draw-circle', inputManager, drawings);
    this.textTool = new DrawingToolViewModel('draw-text', inputManager, drawings, this.textDrawingProps);
    this.deleteTool = new DrawingToolViewModel('draw-delete', inputManager, drawings);
  }

  @computed public get activeTool(): DrawingToolViewModel | undefined {
    if (this.pointTool.isActive) return this.pointTool;
    if (this.polylineTool.isActive) return this.polylineTool;
    if (this.polygonTool.isActive) return this.polygonTool;
    if (this.rectangleTool.isActive) return this.rectangleTool;
    if (this.circleTool.isActive) return this.circleTool;
    if (this.textTool.isActive) return this.textTool;
    if (this.deleteTool.isActive) return this.deleteTool;
    return undefined;
  }
}
